import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function useMediaQueryUtils(size) {
  const theme = useTheme();
  const breakPoint = useMediaQuery(theme.breakpoints.down(size));
  return breakPoint;
}
